/**
 * Route store — leaf module. Tracks the currently-active library/tag/collection/
 * agent/model selection used to drive sidebar + navigation highlighting.
 *
 * No api/socket/store-barrel imports — moved out of store/index.js (Perf 3.1.b)
 * so importers can pull just this slice without the full store monolith.
 */
import { create } from 'zustand';

export const useRouteStore = create((set) => {
  // Helper to set one route and clear others
  const setRoute = (key, id) => {
    set({
      currentLibraryId: key === 'currentLibraryId' ? id : null,
      currentTagId: key === 'currentTagId' ? id : null,
      currentCollectionId: key === 'currentCollectionId' ? id : null,
      currentAgentId: key === 'currentAgentId' ? id : null,
      currentModelId: key === 'currentModelId' ? id : null
    });
  };

  return {
    // States
    currentLibraryId: null,
    currentTagId: null,
    currentCollectionId: null,
    currentAgentId: null,
    currentModelId: null,
    // Actions
    actions: {
      setCurrentLibraryId: (id) => setRoute('currentLibraryId', id),
      setCurrentTagId: (id) => setRoute('currentTagId', id),
      setCurrentCollectionId: (id) => setRoute('currentCollectionId', id),
      setCurrentAgentId: (id) => setRoute('currentAgentId', id),
      setCurrentModelId: (id) => setRoute('currentModelId', id),
      clearRoutes: () => setRoute(null, null)
    }
  };
});

export default useRouteStore;
